import {Component, EventEmitter, forwardRef, Input, Output,} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR,} from '@angular/forms';
import {NepaliDatePickerWrapperComponent} from './nepali-date-picker-wrapper/nepali-date-picker-wrapper.component';
import {AdDatePickerWrapperComponent, DateRestriction} from './ad-date-picker-wrapper/ad-date-picker-wrapper.component';

@Component({
  selector: 'app-common-calendar-ad-bs',
  templateUrl: './common-calendar-ad-bs.component.html',
  styleUrls: ['./common-calendar-ad-bs.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    AdDatePickerWrapperComponent
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CommonCalendarAdBsComponent),
      multi: true,
    },
  ]
})
export class CommonCalendarAdBsComponent implements ControlValueAccessor {
  calendarType: string = 'AD';
  selectedDate: string | null = null;

  private onChange = (_: any) => {
  };
  private onTouched = () => {
  };

  @Input() label!: string;
  @Input() key!: string;
  @Input() shouldFloat!: boolean;

  // NEW: Add these inputs
  @Input() enableTime: boolean = false;
  @Input() readonly: boolean = false;

  @Output() dateChange = new EventEmitter<string>();

  writeValue(outsideValue: any): void {
    this.selectedDate = outsideValue || null;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  // Updated method for custom AD picker
  @Input() dateRestriction: DateRestriction = 'none';
  @Input() minDate: Date | undefined;
  @Input() maxDate: Date | undefined;

  updateAdDate(value: string) {
    this.selectedDate = value;
    this.onChange(value);
    this.onTouched();
    this.dateChange.emit(value);
  }

  updateBsDate(value: string) {
    this.selectedDate = value;
    this.onChange(value);
    this.onTouched();
    this.dateChange.emit(value);
  }
}
